/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Title_CompleteInputs */

const en_us2_workout_after_title_complete = /** @type {(inputs: Workout_After_Title_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout complete`)
};

const pt_br2_workout_after_title_complete = /** @type {(inputs: Workout_After_Title_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino concluído`)
};

const es_419_workout_after_title_complete = /** @type {(inputs: Workout_After_Title_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrenamiento completado`)
};

const pt_pt2_workout_after_title_complete = /** @type {(inputs: Workout_After_Title_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treino concluído`)
};

const fr_fr2_workout_after_title_complete = /** @type {(inputs: Workout_After_Title_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Séance terminée`)
};

const de_de2_workout_after_title_complete = /** @type {(inputs: Workout_After_Title_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Training abgeschlossen`)
};

const it_it2_workout_after_title_complete = /** @type {(inputs: Workout_After_Title_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Allenamento completato`)
};

/**
* | output |
* | --- |
* | "Workout complete" |
*
* @param {Workout_After_Title_CompleteInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_title_complete = /** @type {((inputs?: Workout_After_Title_CompleteInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Title_CompleteInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_title_complete(inputs)
	if (locale === "es-419") return es_419_workout_after_title_complete(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_title_complete(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_title_complete(inputs)
	if (locale === "de-DE") return de_de2_workout_after_title_complete(inputs)
	if (locale === "it-IT") return it_it2_workout_after_title_complete(inputs)
	return en_us2_workout_after_title_complete(inputs)
});
export { workout_after_title_complete as "workout-after.title_complete" }